import { Button } from 'shared-ui';

import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionModal } from 'ui/actionModal/ActionModal';

import { DeleteMultiAnnouncementsProps } from './DeleteMultiAnnouncements.types';

export const DeleteMultiAnnouncements = ({
  checkedAnnouncements,
  isModalOpen,
  onSubmit,
  isLoading,
  onModalClose,
  onModalOpen,
}: DeleteMultiAnnouncementsProps) => {
  const { formatMessage } = useLocale();

  return (
    <>
      <Button variant="outlined" color="primary" size="small" startIcon={<TrashIcon />} onClick={onModalOpen}>
        {formatMessage({ id: AppMessages['announcements.multiAction.delete.button'] })}
      </Button>

      <ActionModal
        header={formatMessage({ id: AppMessages['announcements.multiAction.delete.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        size="medium"
        onSubmit={onSubmit}
        isLoading={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['announcements.multiAction.delete.button'] })}
      >
        <ActionModal.Subtitle>
          {formatMessage({ id: AppMessages['announcements.multiAction.delete.subtitle'] })}{' '}
          {checkedAnnouncements.length}
        </ActionModal.Subtitle>

        <ActionModal.Text>
          {formatMessage({ id: AppMessages['announcements.multiAction.delete.text'] })}
        </ActionModal.Text>

        <ActionModal.Text>{formatMessage({ id: AppMessages['common.irreversibleAction'] })}</ActionModal.Text>
      </ActionModal>
    </>
  );
};
